<template>
  <div v-if="options" class="modal__generic">
    <h3 v-if="options.header" class="modal__header">
      {{ options.header }}
    </h3>

    <p class="modal__text">
      {{ options.text }}
    </p>

    <div class="modal__text">
      <validation-observer
        ref="cancelGiftCardDataForm"
        tag="div">
        <validation-provider
          v-slot="{errors}"
          rules="required"
          slim>
          <oie-base-input
            v-model="cancelledReason"
            :label-text="options.reasonLabel"
            :error-messages="errors"
            :textarea="true"></oie-base-input>
        </validation-provider>
      </validation-observer>
    </div>

    <div class="modal__actions">
      <oie-base-button
        css-classes="button--with-border button--blue"
        text="Makulera"
        @click="cancelGiftCard()"></oie-base-button>

      <oie-base-button
        css-classes="button--true-ghost"
        :text="tStatic('modalCancel')"
        @click.native="options.closeHandler ? options.closeHandler() : $modal.hide(options.name)"></oie-base-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    cancelledReason: null
  }),
  methods: {
    cancelGiftCard() {
      this.$refs.cancelGiftCardDataForm.validate().then(success => {
        if (success) {
          this.options.handler(this.cancelledReason)
        }
      })
    }
  }
}
</script>

<style lang="scss">
.modal__actions {
  display: flex;
  align-items: center;
}

.modal__actions > * + * {
  margin-left: measure(quarter);
}
</style>
